var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 5,
    viewBox: "0 0 10 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.79231 0.206184C9.72592 0.140851 9.64693 0.0889952 9.55989 0.0536073C9.47286 0.0182193 9.37951 0 9.28523 0C9.19095 0 9.09759 0.0182193 9.01056 0.0536073C8.92353 0.0889952 8.84454 0.140851 8.77814 0.206184L5.50708 3.39864C5.44069 3.46397 5.3617 3.51583 5.27467 3.55122C5.18763 3.58661 5.09428 3.60483 5 3.60483C4.90572 3.60483 4.81237 3.58661 4.72533 3.55122C4.6383 3.51583 4.55931 3.46397 4.49291 3.39864L1.22186 0.206184C1.15546 0.140851 1.07647 0.0889952 0.989437 0.0536073C0.902405 0.0182193 0.809054 0 0.714771 0C0.620487 0 0.527137 0.0182193 0.440104 0.0536073C0.353072 0.0889952 0.27408 0.140851 0.207685 0.206184C0.0746641 0.336784 0 0.513451 0 0.697599C0 0.881748 0.0746641 1.05841 0.207685 1.18901L3.48589 4.38844C3.88763 4.78004 4.4322 5 5 5C5.56779 5 6.11237 4.78004 6.51411 4.38844L9.79231 1.18901C9.92533 1.05841 10 0.881748 10 0.697599C10 0.513451 9.92533 0.336784 9.79231 0.206184Z",
    fill: "#565A6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.1df165266e3e7df17b9504b20317f40e.svg";
export { ForwardRef as ReactComponent };